import { Box, Grid, styled, Typography } from '@mui/material';

export const StepIconContainer = styled(Box)<{ disabled?: boolean }>(({ disabled }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: disabled ? 'auto' : 'pointer',
}));

export const OnboardingFlowCard = styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: '4px',
  backgroundColor: 'white',
  padding: theme.spacing(2.5),
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  maxHeight: '600px',
  overflowY: 'auto',
}));

export const OnboardingFlowStepContainer = styled(Box)<{ activeStep?: number }>(({ theme, activeStep }) => ({
  width: '100%',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: `${theme.spacing(5)} ${theme.spacing(10)}`,
  marginTop: theme.spacing(10),
  transition: 'transform 0.75s ease-in-out',
  transform: `translateY(${activeStep * -100}vh)`,
}));

export const OnboardingFlowCardContentContainer = styled(Box)(({ theme }) => ({
  width: '90%',
  marginTop: theme.spacing(1.25),
}));

export const OnboardingFlowCardContentRow = styled(Grid)<{ fullWidth?: boolean }>(({ theme, fullWidth }) => ({
  gap: fullWidth ? 0 : theme.spacing(1.25),
  padding: theme.spacing(1.25),
}));

export const OnboardingFlowCardField = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1),
}));

export const OnboardingFlowCardActionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '20px',
  padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
  marginLeft: 'auto',
}));

export const OnboardingCardError = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(3),
  color: theme.palette.error.main,
}));
